import { LoadablePaint, LoadableAfterPaint } from '@confluence/loadable';

export const EngagementInlineDialogLoaderNav3 = LoadableAfterPaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EngagementInlineDialogWrapper" */ './EngagementInlineDialogWrapper'
			)
		).EngagementInlineDialogWrapper,
});

export const EngagementInlineDialogLoader = LoadablePaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EngagementInlineDialogWrapper" */ './EngagementInlineDialogWrapper'
			)
		).EngagementInlineDialogWrapper,
});
